import Vue from 'vue'

const searchTuneModal = {
  state: {
    customerPlayListId: 0,
    playListType: 0,
    playListIndex: 0,
    sceneId: 0,
    showFlag: false
  },
  mutations: {
    updateCustomerPlayListId (state, customerPlayListId) {
      state.customerPlayListId = customerPlayListId
    },
    updateShowFlag (state, boolean) {
      state.showFlag = boolean
    },
    updatePlayListType (state, playListType) {
      state.playListType = playListType
    },
    updatePlayListIndex (state, playListIndex) {
      state.playListIndex = playListIndex
    },
    updateSceneId (state, sceneId) {
      state.sceneId = sceneId
    }
  },
  actions: {
    setSearchModal (context, [booleanShowModal, playListType, customerPlayListId, playListIndex, sceneId]) {
      Vue.$log.debug('setSearchModal START', booleanShowModal, playListType, customerPlayListId, playListIndex, sceneId)
      this.commit('updateShowFlag', booleanShowModal)
      this.commit('updatePlayListType', playListType)
      this.commit('updateCustomerPlayListId', customerPlayListId)
      this.commit('updatePlayListIndex', playListIndex)
      this.commit('updateSceneId', sceneId)
      Vue.$log.debug('setSearchModal END', booleanShowModal, playListType, customerPlayListId, playListIndex, sceneId)
    },
    closeSearchTuneModal () {
      this.commit('updateShowFlag', false)
    }
  },
  getters: {
    getSearchTuneModalSceneId (state) {
      return state.sceneId
    },
    getSearchTuneModalCanSearchSceneId (state) {
      let result = null
      switch (parseInt(state.sceneId)) {
        case 14:
        case 15:
          result = null
          break
        default:
          result = parseInt(state.sceneId)
          break
      }
      return result
    }
  }
}
export default searchTuneModal



// WEBPACK FOOTER //
// ./src/store/searchTuneModal.js